import {Action, ActionTypeEnum} from './Action';
import {Value} from "./Value";
import {Interval, IntervalMode} from "./Interval";

export { Value, IntervalMode, Interval };

export class DatePiker {
    _actions: Array<Action>;

    constructor() {
        this._actions = [
           // new Action(ActionTypeEnum.ALL_TIME, 'За всё время', () => {
           //      return null;
           //  }),
            Action.createByInterval(ActionTypeEnum.ALL_TIME, IntervalMode.ALL_TIME),
            Action.createByInterval(ActionTypeEnum.TODAY, IntervalMode.TODAY),
            Action.createByInterval(ActionTypeEnum.YESTERDAY, IntervalMode.YESTERDAY),
            Action.createByInterval(ActionTypeEnum.WEEK, IntervalMode.WEEK),
            Action.createByInterval(ActionTypeEnum.MONTH, IntervalMode.MONTH),
            Action.createByInterval(ActionTypeEnum.YEAR, IntervalMode.YEAR),
            new Action(ActionTypeEnum.EXACT_DATE, 'Точная дата', (value) => {
                if (!(value instanceof Date)) {
                    throw new Error;
                }
                return Value.createByDate(value);
            }),
            new Action(ActionTypeEnum.MANUAL_PERIOD, 'Произвольный период...', (value: Interval) => {
                return Value.createByPeriod(value.start, value.end);
            }),
        ]
    }

    _getActionByType(type: ActionTypeEnum): Action|null {
        return this._actions.find((action: Action) => action.type === type);
    }

    getActionByValue(value: Value|null): Action|null {
        if (!value) {
            return null;
        }

        if (value.mode) {
            switch (value.mode) {
                case IntervalMode.TODAY:
                    return this._getActionByType(ActionTypeEnum.TODAY);
                case IntervalMode.YESTERDAY:
                    return this._getActionByType(ActionTypeEnum.YESTERDAY);
                case IntervalMode.WEEK:
                    return this._getActionByType(ActionTypeEnum.WEEK);
                case IntervalMode.MONTH:
                    return this._getActionByType(ActionTypeEnum.MONTH);
                case IntervalMode.YEAR:
                    return this._getActionByType(ActionTypeEnum.YEAR);
            }
        }

        if (value.date) {
            return this._getActionByType(ActionTypeEnum.EXACT_DATE);
        }
        if (value.interval) {
            return this._getActionByType(ActionTypeEnum.MANUAL_PERIOD);
        }

        return null;
    }

    get actions(): Array<Action> {
        return this._actions;
    }
}
